import FooterSocieties from './FooterSocieties'

export default FooterSocieties